<div class="filter-tournament-year">
    <button
        *ngFor="let filterYOption of filterTournamentYearOptions"
        [class.active]="filterTournamentYear === filterYOption.filter"
        (click)="changeFilter(filterYOption)"
    >
        {{ filterYOption.label }}
    </button>
</div>
